export const BIGRAM_REGEXP = /^[a-zA-Z]{2}$/;
